import { BaseModalProps, ModalButton, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType, ModalType } from '@philips-internal/oswald-ui-constants';
import { AbortableCloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { InfusionScreenType } from '../../../constants/infusion-solutions';
import { AdminByScheduleParams } from '../eletronic-prescription/administration-schedule/administration-schedule-params';
import { InfusionsViewerParams } from '../infusion-viewer/infusions-viewer-params';
import { PrescriptionStatus } from '../eletronic-prescription/administration-schedule/administration-schedule-types';

export interface AdminContextDataProps {
  medicationOrSolution?: string;
  processSequence?: number;
}

export class AdminModalsService {

  public static redirectToTimeline(id: string): void {
    ModalService.close(id);
    ModalService.close('dialog-modal-service');
  }

  public static dialogModalConfirm(event: AbortableCloseEvent, id: string): void {
    const noCardsRead = AdminByScheduleParams.readParam?.noCardsRead;
    const isFirstChecked = AdminByScheduleParams.params?.isFirstChecked;

    if (noCardsRead || isFirstChecked === PrescriptionStatus.CHECKED_FIRST) {
      ModalService.close(id);
      ModalService.close('dialog-modal-service');
      return;
    }

    event.abort();

    const buttons: ModalButton[] = [];

    buttons.push({
      action: () => { },
      title: 'tws.biometry.cancel',
      type: ModalButtonType.CANCEL,
    });

    buttons.push({
      action: () => this.redirectToTimeline(id),
      title: 'tws.file-uploader-modal.confirm',
      type: ModalButtonType.SUCCESS,
    });

    const dialogModal: BaseModalProps = {
      dialogDescription: MessageService.translate('text.reset items-want-to-continue'),
      dockButtons: buttons,
      focusOnOpen: true,
      id: 'dialog-modal-service',
      title: 'text.message-alert-attention',
    };

    ModalService.openDialog(dialogModal);
  }

  public static modalAdminByProcessOrScheduleIsVisible(
    itemType: string,
    {
      processSequence,
      medicationOrSolution
    }: AdminContextDataProps,
    doubleCheckPerformed?:  boolean): void {
    const processTitleDescription = MessageService.translate('text.medication-of-process').replace('#@NR_PROCESSO#@', String(processSequence));
    const scheduleTitleDescription = MessageService.translate(this.getTitleDescription());
    let id = '';
    let fragment = '';
    let modaltitle = '';

    switch (itemType) {
      case 'medication-admin-process':
        id = 'medication-administration-by-process';
        fragment = 'medication-administration-by-process';
        modaltitle = processTitleDescription;
        break;
      case 'medication-admin-schedule':
        id = 'administration-by-schedule';
        fragment = 'administration-by-schedule';
        modaltitle = scheduleTitleDescription;
        break;
      case 'infusion-admin-process':
        id = 'infusion-administration-by-process';
        fragment = 'medication-administration-by-process';
        modaltitle = scheduleTitleDescription;
        break;
      case 'infusion-admin-schedule':
        id = 'infusion-administration-by-schedule';
        fragment = 'infusion-administration-by-schedule';
        modaltitle = scheduleTitleDescription;
        break;
      case 'finish-chemotherapy-medication':
        id = 'administration-by-schedule';
        fragment = 'administration-by-schedule';
        modaltitle = 'text.finish';
        break;
      default:
        null;
    }

    const dialogModal: BaseModalProps = {
      contextData: {
        adminContextData: {
          medicationOrSolution,
          processSequence,
        },
        doubleCheckPerformed
      },
      focusOnOpen: false,
      fragment,
      id,
      onBeforeClose: (event) => this.dialogModalConfirm(event, id),
      title: modaltitle,
      type: ModalType.DEFAULT,
    };

    ModalService.openDefault(dialogModal);
  }

  private static getTitleDescription(): string {
    const administration = 'text.emar-administration';
    const startSolution = 'button.infusion-viewer.start';
    const restartSolution = 'button.infusion-viewer.restart-solution';
    const firstCheck = 'button.infusion-viewer.first-check';

    switch (InfusionsViewerParams.infusionScreenType) {
      case InfusionScreenType.START_SOLUTION: return startSolution;
      case InfusionScreenType.RESTART_SOLUTION: return restartSolution;
      case InfusionScreenType.ADMIN_BY_SCHEDULE: return administration;
      case InfusionScreenType.FIRST_CHECK: return firstCheck;
      default: return administration;
    }
  }

}
